import DestructiveActionConfirmationModal from './DestructiveActionConfirmationModal'

export default DestructiveActionConfirmationModal
